var exports = {
  "DR": "Box_0__Et2Nfj",
  "wy": "Box_1__2Rc0BT",
  "U3": "ActionList_0__Ssg8Xf",
  "w9": "Box_3__5y8X8a",
  "Gk": "showOverlay__OBB_AI",
};

module.exports = exports;
